export default value => (value ? 'Ja' : 'Nej');
